import { d as doApplicationMount, a as doApplicationUnmount } from "./_internal-8e885689.mjs";
import { MalarkeySSRPlugin } from "./utilities/ssr.es.js";
import "./sudo-bad5b55e.mjs";
import "./index-64135f7d.mjs";
import "./i18n-35335a5c.mjs";
import "./index-38c53cf2.mjs";
import "./_i18n-e414d464.mjs";
import "./index-703c58ee.mjs";
import "vue";
import "./malarkeyTwilioAdapter-1c296255.mjs";
import "./index-13be80af.mjs";
import "./_commonjsHelpers-ca272635.mjs";
import "./_debug-8b5c3032.mjs";
import "joi";
import "./helpers-674591c1.mjs";
import "./event-socket/malarkeyEventSocketAdapter.es.js";
import "./otpauth.esm-675c01d0.mjs";
import "./index-fd2245c5.mjs";
import "./_ui-71f9b37c.mjs";
import "./_patches-94e7586e.mjs";
function install(app, options) {
  if (app.malarkey) {
    return;
  }
  if (!app.malarkeySSR) {
    MalarkeySSRPlugin.install(app, options);
  }
  const originalMount = app.mount;
  const originalUnmount = app.unmount;
  app.mount = doApplicationMount.bind(app, options, originalMount);
  app.unmount = doApplicationUnmount.bind(app, originalUnmount);
}
const MalarkeyClientCore = {
  commitSha: "d93d64ebda33501e3a597b4d8fe24c39b8bca50d",
  commitShortSha: "d93d64eb",
  commitTag: "v1.20240912.0",
  environmentTier: "development",
  commitRefName: "v1.20240912.0",
  commitBranch: "master"
};
export {
  MalarkeyClientCore,
  install
};
//# sourceMappingURL=index.es.js.map
